export default __webpack_public_path__ + "static/media/resolucao.b70e3a6a.pdf";